import type { MenuCommand, ObjectMenuCommands } from '../types/menu-items'
import type { MenubarInputs } from '../types/menubar-inputs'

/**
 * Object-menu rows shared by the desktop dropdown and the mobile sheet. Lock/Unlock and
 * Freeze/Unfreeze each occupy one row that swaps on `showUnlockSelected` / `showUnfreezeSelected`.
 */
export function buildObjectMenuCommands({
  onGroupObjects,
  onUngroupObjects,
  groupObjectsDisabled = false,
  ungroupObjectsDisabled = false,
  onLockSelected,
  onUnlockSelected,
  onFreezeSelected,
  onUnfreezeSelected,
  onUnlockAll,
  onUnfreezeAll,
  lockSelectedDisabled = false,
  unlockSelectedDisabled = false,
  freezeSelectedDisabled = false,
  unfreezeSelectedDisabled = false,
  unlockAllDisabled = false,
  unfreezeAllDisabled = false,
  convertTextToShapeDisabled = false,
  onConvertTextToShape,
  onTextOnPath,
  textOnPathDisabled = false,
  showUnlockSelected = false,
  showUnfreezeSelected = false,
}: MenubarInputs): ObjectMenuCommands {
  const lockRow: MenuCommand = showUnlockSelected
    ? {
        label: 'Unlock Selected',
        shortcutKey: 'unlock',
        action: onUnlockSelected,
        disabled: unlockSelectedDisabled,
      }
    : {
        label: 'Lock Selected',
        shortcutKey: 'lock',
        action: onLockSelected,
        disabled: lockSelectedDisabled,
      }

  const freezeRow: MenuCommand = showUnfreezeSelected
    ? {
        label: 'Unfreeze Selected',
        shortcutKey: 'toggleFreeze',
        action: onUnfreezeSelected,
        disabled: unfreezeSelectedDisabled,
      }
    : {
        label: 'Freeze Selected',
        shortcutKey: 'toggleFreeze',
        action: onFreezeSelected,
        disabled: freezeSelectedDisabled,
      }

  return {
    grouping: [
      {
        label: 'Group',
        shortcutKey: 'group',
        action: onGroupObjects,
        disabled: groupObjectsDisabled,
      },
      {
        label: 'Ungroup',
        shortcutKey: 'ungroup',
        action: onUngroupObjects,
        disabled: ungroupObjectsDisabled,
      },
    ],
    locking: [
      lockRow,
      freezeRow,
      { label: 'Unlock All', action: onUnlockAll, disabled: unlockAllDisabled },
      { label: 'Unfreeze All', action: onUnfreezeAll, disabled: unfreezeAllDisabled },
    ],
    convertTextToShape: {
      label: 'Convert Text to Shape',
      action: onConvertTextToShape,
      disabled: convertTextToShapeDisabled,
    },
    textOnPath: { label: 'Text on Path', action: onTextOnPath, disabled: textOnPathDisabled },
  }
}
